import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record',
)({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'customer-sweep-record',
        label: 'Core',
        to: '/clearing/operations/customer-sweep-record',
      }),
    }) satisfies AggregateBreadcrumb,
});
